import { PlusOutlined } from '@ant-design/icons';
import { Button, Empty, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PodSearchIcon from 'assets/img/pod-search-icon.svg?react';

import s from './styles.module.scss';

import type { FC } from 'react';

const { Text } = Typography;

interface IPodEmptyStateProps {
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  onCreatePod: () => void;
}

const PodEmptyState: FC<IPodEmptyStateProps> = ({
  hasActiveFilters,
  onClearFilters,
  onCreatePod,
}) => {
  const { t } = useTranslation();

  if (hasActiveFilters) {
    return (
      <div className={s.emptyState}>
        <Empty
          image={<PodSearchIcon width={64} height={40} aria-hidden />}
          description={
            <>
              <Text strong>{t('labels.noMatchingPods')}</Text>
              <br />
              <Text className={s.helperText}>
                {t('labels.noMatchingPodsHelper')}
              </Text>
            </>
          }
          data-cy="pod-list__empty-no-match"
        >
          <Button
            type="link"
            onClick={onClearFilters}
            className={s.clearFiltersBtn}
            data-cy="pod-list__clear-all-filters"
          >
            {t('labels.clearAllFilters')}
          </Button>
        </Empty>
      </div>
    );
  }

  return (
    <div className={s.emptyState}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <>
            <Text strong>{t('labels.noPodsCreated')}</Text>
            <br />
            <Text className={s.helperText}>
              {t('labels.noPodsCreatedHelper')}
            </Text>
          </>
        }
        data-cy="pod-list__empty-no-data"
      >
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onCreatePod}
          data-cy="pod-list__empty-create-btn"
        >
          {t('labels.createPod')}
        </Button>
      </Empty>
    </div>
  );
};

export default PodEmptyState;
